import { Component, NgZone, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Events } from '@services/events/events.service';

import {
  IHeaderSetting,
  FilterElementService,
  TableService,
  ResizeHandlerService,
  LoadingService,
  Module
} from '@services';
import { ObservationTableService } from '@services/observationTableService/observation-table-service.service';
import { TranslateService } from '@ngx-translate/core';
import { each, find } from 'lodash';

@Component({
  selector: 'app-coaching-table',
  templateUrl: './coaching-table.page.html',
  styleUrls: ['./coaching-table.page.scss'],
})
export class CoachingTablePage {
  public headerSetting: IHeaderSetting = {
    title: this.translate.instant('DASHPAGES.COACHING_TABLE_text1'),
    filter: {
      showFilter: true,
      isActive: false
    },
    showSearchField: true,
    selectDropDown: {
      dataNavMenuKey: Module.OBSERVATIONS,
      option: {
        minimumResultsForSearch: Infinity,
        placeholder: this.translate.instant('SHARED.COACHING_TABLE_placeholder'),
        width: '15em',
        closeOnSelect: true,
        sorter: (data) => data
      },
      defaultVal: null
    }
  };
  public filterObject = this.observationTableService.filterObject;
  public filterComps: any = [];
  public showFilterBody = false;
  public searchField: any = '';
  private menuItem: any = ['location', 'team', 'user', 'zone', 'timespan'];
  private tableData: any = {};
  private filterString: string = null;
  private clearFilter = false;

  constructor(
    private observationTableService: ObservationTableService,
    private events: Events,
    private zone: NgZone,
    private filterElem: FilterElementService,
    private tableService: TableService,
    private resizeHandler: ResizeHandlerService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private loadingService: LoadingService,
    private elementRef: ElementRef
  ) {
  }

  ionViewWillEnter() {
    const clearSearch: string = this.route.snapshot.queryParamMap.get('clearSearch');
    if (clearSearch) {
      this.searchField = '';
      this.observationTableService.filterObject.searchString = null;
      $('.observation-search-field').val(null);
    } else {
      this.searchField = this.observationTableService.filterObject.searchString;
      $('.observation-search-field').val(this.searchField);
    }

    this.events.subscribe('ccs:observationUpdate', this.observationUpdateListener);
    this.events.subscribe('ccs:filterObject', this.filterListener);
    this.events.subscribe('ccs:searchString', this.searchStringListener);
    this.events.subscribe('ccs:clearMenu', this.clearMenuListener);
  }

  ionViewDidEnter() {
    this.prepData();

    this.loadingService.enable().then(() => {
      this.buildTableElements({
        id: 'coachingData'
      });
    });
    this.filterComps = this.filterElem.buildFilterObjects(this.menuItem, this.observationTableService.filterObject);
    if (this.observationTableService.filterValuesAvailable(this.filterComps)) {
      this.headerSetting.filter.isActive = true;
    } else {
      this.headerSetting.filter.isActive = false;
    }
    this.resizeHandler.addResizeHandler('coachingTable', () => this.tableService.handleResize('.dataTables_scrollBody:visible:last', 50, null));
    this.clearFilter = this.route.snapshot.queryParamMap.get('clearFilter') === 'true';
  }

  buildTableElements(tab) {
    this.observationTableService.initDataTable(`#${[tab.id]}`, this.tableData[tab.id], tab, this.filterString);
  }

  public toggleFilterBody(val) {
    this.showFilterBody = val;
    // check if custom is active on time span
    const timeBlock: any = find(this.filterComps, {id: 'timespan'});
    if (timeBlock.value[0] === 'custom') {
      $(this.elementRef.nativeElement).find('#timespan select').val([]);
    }
  }

  ionViewWillLeave() {
    this.resizeHandler.removeResizeHandler('coachingTable');
    this.events.unsubscribe('ccs:filterObject', this.filterListener);
    this.events.unsubscribe('ccs:clearMenu', this.clearMenuListener);
    this.events.unsubscribe('ccs:observationUpdate', this.observationUpdateListener);
    this.events.unsubscribe('ccs:searchString', this.searchStringListener);
    if (this.clearFilter) {
      this.observationTableService.clearFilterObject();
    }
  }

  private searchStringListener = (data) => {
    this.observationTableService.filterObject = data; // get filter elem
    this.prepData();
    this.buildTableElements({id: 'coachingData'});
  };

  private observationUpdateListener = (data) => {
    if (data) {
      this.prepData();
      this.buildTableElements({
        id: 'coachingData'
      });
    }
  };

  private filterListener = (data) => {
    this.observationTableService.filterObject = data; // get filter elem
  };

  private clearMenuListener = (data) => {
    if (data) {
      this.zone.run(() => {
        // tslint:disable-next-line:max-line-length
        this.filterComps = this.filterElem.buildFilterObjects(this.menuItem, this.observationTableService.filterObject);
        let checkFilterActive = false;
        each(this.filterComps, comp => {
          if (comp.value && comp.value.length > 0) {
            checkFilterActive = true;
            return false;
          }
        });
        this.headerSetting.filter.isActive = checkFilterActive;
        this.prepData();

        setTimeout(() => {
          this.buildTableElements({id: 'coachingData'});
        });
      });
    }
  };

  private prepData() {
    // need to update end time to capture new incoming observaitons
    if (this.observationTableService.filterObject.endTime && this.observationTableService.filterObject.timespan !== 'custom') {
      const endTimeNow = Date.now();
      this.observationTableService.filterObject.endTime = endTimeNow;
    }

    if (!this.filterObject.timespan) {
      this.filterObject.timespan = 'all';
    }
    const rawData = this.observationTableService.getObservation('behavior');
    if (rawData.rows.resolved) {
      this.tableData.coachingData = rawData.rows.resolved.items;
    } else {
      this.tableData.coachingData = [];
    }
    this.filterString = this.filterObject.searchString;
  }

}
